// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1COZj","footer":"ModalFilter_footer__1vHle"};